import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily:
      "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "1rem",
          fontWeight: "normal",
          textTransform: "unset",
        },
        containedPrimary: ({ ownerState }) => ({
          backgroundColor: ownerState.btnColors.btnPrimary,

          color: ownerState.btnColors.btnFontPrimary,
          "&:hover": {
            backgroundColor: ownerState.btnColors.btnPrimaryHover,
          },
        }),
        containedSecondary: ({ ownerState }) => ({
          backgroundColor: ownerState.btnColors.btnSecondary,
          color: ownerState.btnColors.btnFontSecondary,
          "&:hover": {
            backgroundColor: ownerState.btnColors.btnSecondaryHover,
          },
        }),
        text: {
          padding: "0 4px",
          width: "auto",
        },
        textPrimary: ({ ownerState }) => ({
          color: ownerState.btnColors.btnTextFontPrimary,
        }),
        textSecondary: ({ ownerState }) => ({
          color: ownerState.btnColors.btnTextFontSecondary,
        }),
      },
    },
    // MuiSelect: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(15px)",
    //     },
    //   },
    // },
    // MuiMenu: {
    //   styleOverrides: {
    //     paper: {
    //       background: "transparent",
    //       backdropFilter: "blur(15px)",
    //       boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    //     },
    //   },
    // },
    // MuiAutocomplete: {
    //   styleOverrides: {
    //     paper: {
    //       background: "transparent",
    //       backdropFilter: "blur(15px)",
    //       boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    //     },
    //   },
    // },
    // MuiPopper: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(15px)",
    //     },
    //   },
    // },
  },
});
